import updateMe from "./update-me.js";
import sendResetPassword from "./send-reset-password.js";
import resetPassword from "./reset-password.js";
import checks from "./checks/index.js";

export default {
	checks,
	updateMe,
	sendResetPassword,
	resetPassword,
};
